$(document).ready(function(){

    //Navbar slide on scroll
    var bar = $('header');
    var scrolled = "bar-scrolled";
    

    $(window).scroll(function () {
    	var height = $('#incentive').height();
    	if ($(this).scrollTop() > height) {
    		bar.addClass(scrolled);
    	} else {
    		bar.removeClass(scrolled);
    	}
    });
    //Data toggle

    $(document).on('click', '[data-toggle]', function(){
    	var target = $(this).data('toggle');
    	$(target).toggle();
    });

    //Clicked dropdown header
    $(".e-intro").click(function () {
    	$(this).toggleClass("expanded");
    });
    //Clicked select header
    $(".select-item").click(function () {
    	$(this).toggleClass("show-options");
    });

    //Nav Slide
    $('#menu-burger').click(function () {
    	$('body').toggleClass("slide-right")
    });

    //Filters Dropdown
    $('.filter').click(function () {
    	$(this).toggleClass("filter-drop");
    });

    //Data href 
    $(document).on('click', '[data-cart]' ,function(){
    	var url = $(this).data('cart');
    	var _this = $(this);
    	//window.location.href = url;
    	$.get(url,function(){
    		console.log('completed call');
    		update_cart();
    	});

    });

    // Remove
    $(document).on('click','[data-remove]', function(){
    	var _this = $(this);
    	setTimeout(function(){
    		var remove = _this.data('remove');
    		if(remove == 'parent') {
    			_this.parent().remove();
    		}
    	}, 200);
    });


    Shopify.queryParams = {};
    if (location.search.length) {
    	for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    		aKeyValue = aCouples[i].split('=');
    		if (aKeyValue.length > 1) {
    			Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    		}
    	}
    }
    jQuery('.sort-by')
    .val('{{ collection.sort_by | default: collection.default_sort_by | escape }}')
    .bind('click', function(e) {
    	e.preventDefault();
    	Shopify.queryParams.sort_by = jQuery(this).attr('href');
    	location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
    });



    $('#frame-options a').click(function(e){
    	e.preventDefault();
    	var form = $(this).parents('form');
    	var value = $(this).text();

    	form.find('input[name="properties[Frame]"]').val(value);
    	if ($(this).find('input').val() != undefined) {
    		var variant_id = $(this).find('input').val();
    		form.find('[name="id"]').val(variant_id);
    		form.find('[data-toggle="#frame-options"] h6').data('variant', variant_id );
    	}

    	if($(this).find('[name="v_price"]').val() != undefined ) {
    		$('.price h2').text($(this).find('[name="v_price"]').val());
    	}

    	form.find('[data-toggle="#frame-options"]').trigger('click');
    	form.find('[data-toggle="#frame-options"] h6').html($(this).text());
    	
    })


    // Form submission

    $(document).on('submit', 'form.js-submit , .js-submit form', function() {        

    	var callback = $(this).data('callback');    

    	var fn = window[callback];
    	if(typeof fn !== 'function') {
    		fn = function(){

    		};
    	}

    	$.ajax({
    		url     : $(this).attr('action'),
    		type    : $(this).attr('method'),
    		dataType: 'json',
    		data    : $(this).serialize(),
    		success : function( data ) {
    			fn();
    		},
    		error   : function( xhr, err ) {
    			alert('Error');     
    		}
    	});    
    	return false;
    });


    image_zoom = $('.big-photo img')
    .wrap('<span class="photo-wrap"></span>')
    .css('display', 'block')
    .parent();


    image_zoom.zoom();

    //Image picker 
  
  $(document).on('click','.single-artwork .preview', function(e){
  	e.preventDefault();

    	var image = $(this).attr('href');
    	if(image == '') return;
    	var loading = $('<div><img src="'+image+'" alt="" /></div>');
    	loading.hide().appendTo('body');
    	

    	var current = $('.big-photo img').attr('src');
    	if( current != image) {
    		image_zoom.trigger('zoom.destroy');
    		$('.big-photo img').animate(
    			{opacity: 0 },
    			500,
    			function(){

    				console.log("Image loaded");
    				loading.find('img').css({opacity: 0});
    				$('.big-photo img').replaceWith(loading.find('img'));
    				$('.big-photo img').animate({opacity:1},500);

    				image_zoom.zoom();
    			}
    			);
    	}
  });
  
  
    $('.single-artwork .preview').click(function(e){
    	





    });

    

});


update_cart = function() {
	console.log("Updating cart");	

	$('.basket').load('/cart .basket > * ', function(data){
		$('.basket h6 ').trigger('click');		
	});

	$('[action="/cart/add"] button').attr('disabled','disabled');
	$('[action="/cart/add"] button').text("Item added");
	
}

